<main>
    <h1 class="portal-name">{{portalName}}</h1>
    <router-outlet></router-outlet>
</main>